import { useQuery } from '@tanstack/react-query'
import api from '../lib/api'
import { useTestDataVisibility } from '../context/TestDataVisibilityContext'
import { useEffectiveUser } from './useEffectiveUser'

export interface DemandCaretakerOption {
  id: number
  name: string
  count: number
}

export function useDemandCaretakers(focusArea?: string, includeDeleted = false) {
  const { showTestData } = useTestDataVisibility()
  const user = useEffectiveUser()
  return useQuery({
    queryKey: ['demands', 'caretakers', focusArea, includeDeleted, showTestData, user?.id, user?.role, user?.views_all_demands, user?.dsai_cluster_lead],
    queryFn: async ({ signal }) => {
      const { data } = await api.get<DemandCaretakerOption[]>('/demands/caretakers', {
        signal,
        params: {
          focus_area: focusArea || undefined,
          include_test: showTestData,
          include_deleted: includeDeleted,
        },
      })
      return data
    },
    staleTime: 30_000,
  })
}
